class ClickAndCollectWrapper extends HTMLElement {
    connectedCallback() {
        this.tabs = this.querySelectorAll(".tab-item-content");
        this.contents = this.querySelectorAll(".tab-content-pickup");
        this.listContainer = null;
        this._delegateBound = false;

        this.bindTabEvents();
        this.waitForPickupElements();
    }

    bindTabEvents() {
        this.tabs.forEach(tab => {
        tab.addEventListener("click", () => {
            this.activateTab(tab);
            if ( tab.classList.contains('tab-click-and-collect') &&
            !localStorage.getItem("selectedPickupStore")) {
                const dialog = document.querySelector('#ShowPickupAvailabilityDrawer');
                if (dialog) {
                    dialog.click();
                }
            }
        });
        });
    }

    activateTab(tab) {
        this.tabs.forEach(t => {
            t.classList.remove("active");
            t.classList.add("change-backgroud");
        });

        this.contents.forEach(c => c.classList.add("hidden"));

        tab.classList.add("active");
        tab.classList.remove("change-backgroud");

        const id = tab.dataset.tab;
        this.querySelector(`#${id}`)?.classList.remove("hidden");
    }

    waitForPickupElements() {
        const check = () => {
            const infoContainer = this.querySelector(".pickup__info");
            const pickupItems = Array.from(this.querySelectorAll(".pickup__list__item"));

            if (infoContainer && pickupItems.length) {
                this.infoContainer = infoContainer;
                this.pickupItems = pickupItems;
                this.listContainer = this.querySelector(".pickup__list") || this.listContainer;
                this.bindPickupEvents();
                this.initSearch();
                this.restoreSelection();
            } else {
                requestAnimationFrame(check);
            }
        };
        check();
    }

    initSearch() {
        const searchInput = this.querySelector("#pickup-search");
        if (!searchInput) return;

        const wrapper = this;

        searchInput.setAttribute('inputmode', 'numeric');
        searchInput.setAttribute('pattern', '[0-9]*');

        searchInput.addEventListener('beforeinput', function (e) {
            const data = e.data || '';
            if (e.inputType && (e.inputType.startsWith('insert'))) {
                if (/\D/.test(data)) {
                    e.preventDefault();
                }
            }
        });

        let composing = false;
        searchInput.addEventListener('compositionstart', function () { composing = true; });
        searchInput.addEventListener('compositionend', function (e) {
            composing = false;
            if (/\D/.test(e.data || '')) {
                this.value = this.value.replace(/\D/g, '');
                this.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });

        searchInput.addEventListener('paste', function (e) {
            const paste = (e.clipboardData || window.clipboardData).getData('text') || '';
            if (/\D/.test(paste)) {
                e.preventDefault();
                const digits = paste.replace(/\D/g, '');
                const start = this.selectionStart || 0;
                const end = this.selectionEnd || 0;
                const newVal = this.value.slice(0, start) + digits + this.value.slice(end);
                this.value = newVal;
                const pos = start + digits.length;
                this.setSelectionRange(pos, pos);
                this.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });

        searchInput.addEventListener('keydown', function (e) {
            if (["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)) {
                return;
            }
            if (composing) return;

            if (!/^[0-9]$/.test(e.key)) {
                e.preventDefault();
            }
        });

        searchInput.addEventListener('input', function (e) {
            const input = this;
            const sanitized = input.value.replace(/\D/g, '');
            if (input.value !== sanitized) {
                input.value = sanitized;
                input.setSelectionRange(sanitized.length, sanitized.length);
            }

            const keyword = input.value.trim();

            wrapper.pickupItems = Array.from(wrapper.querySelectorAll(".pickup__list__item"));

            if (!keyword) {
                wrapper.pickupItems.forEach(item => item.style.display = "");
                return;
            }

            const keywordNum = parseInt(keyword, 10);
            const firstDigit = keyword.charAt(0);

            const matched = wrapper.pickupItems
                .map(item => {
                    const zipText = item.querySelector(".address-zipcode-location")?.innerText.trim() || "";
                    const zipNum = parseInt(zipText, 10) || 0;

                    return {
                        el: item,
                        zip: zipNum,
                        text: zipText
                    };
                })
                .filter(obj => obj.text.startsWith(firstDigit))
                .sort((a, b) => Math.abs(a.zip - keywordNum) - Math.abs(b.zip - keywordNum));

            wrapper.pickupItems.forEach(item => item.style.display = "none");

            matched.forEach(obj => {
                obj.el.style.display = "";
                if (wrapper.listContainer) {
                    wrapper.listContainer.appendChild(obj.el);
                }
            });
        });
    }

    bindPickupEvents() {
        if (!this._delegateBound) {
            this._onWrapperClick = (e) => {
                const button = e.target.closest('.select-pick-up-address');
                if (!button) return;
                const item = button.closest('.pickup__list__item');
                if (item) this.selectStore(item);
            };
            this.addEventListener('click', this._onWrapperClick);
            this._delegateBound = true;
        }

        const dialogs = this.querySelectorAll("dialog");
        dialogs.forEach(d => {
            if (d.dataset.ccDialogInit) return;
            d.dataset.ccDialogInit = '1';
            d.addEventListener("close", () => this.resetSearch());
        });
    }

    selectStore(item) {
        const content = item.querySelector(".pick-up-item-content")?.innerHTML || "";
        const storeName = item.querySelector(".address_name")?.innerText.trim() || "";
        const storeAddress = item.querySelector(".address_infor")?.innerText.trim() || "";
        const storePhone = item.querySelector(".phone a")?.innerText.trim() || "";

        const labelStore = this.querySelector(".click-and-collect-title-sub");
        if (labelStore) labelStore.textContent = storeName;

        const itemStatus = item.querySelector(".status-pickup")?.querySelector("svg")?.innerHTML || "";
        const reportStatus = this.querySelector(".click-and-collect-title")?.querySelector("svg");
        if (reportStatus) reportStatus.innerHTML = itemStatus;

        const propertyPickup = document.querySelector("#pick-up-property");
        if (propertyPickup) {
            propertyPickup.value = '';
            propertyPickup.value = storeName;
        }

        if (this.infoContainer) {
            const target = this.infoContainer.querySelector(".pick-up-item-content");
            if (target) target.innerHTML = content;
        }

        const variantPickup = this.querySelector(".pick-up-location-variant");
        if (variantPickup) {
            localStorage.setItem("selectedVariant", variantPickup.textContent);
        }
        localStorage.setItem("selectedPickupStore", storeName);
        localStorage.setItem("selectedPickupAddress", storeAddress);
        localStorage.setItem("selectedPickupPhone", storePhone);

        this.markSelectedUI(item);

        this.resetSearch();
        item.closest("dialog")?.close();

        this.updateCartPickupStore(storeName);
    }

    markSelectedUI(item) {
        this.pickupItems = Array.from(this.querySelectorAll(".pickup__list__item"));

        this.pickupItems.forEach(i => {
            i.classList.remove("pickup-selected");
            this.updateButtonLabel(i, "SELECT");
        });

        item.classList.add("pickup-selected");
        this.updateButtonLabel(item, "SELECTED");

        const parent = item.parentNode;
        if (parent) parent.prepend(item);

        const storeName = item.querySelector(".address_name")?.innerText.trim() || "";
        const itemStatus = item.querySelector(".status-pickup")?.querySelector("svg")?.innerHTML || "";
        const reportStatus = this.querySelector(".click-and-collect-title")?.querySelector("svg");
        if (reportStatus) reportStatus.innerHTML = itemStatus;
        const labelStore = this.querySelector(".click-and-collect-title-sub");
        if (labelStore) labelStore.textContent = storeName;

        const propertyPickup = document.querySelector("#pick-up-property");
        if (propertyPickup) propertyPickup.value = storeName;

        this.pickupItems = Array.from(this.querySelectorAll(".pickup__list__item"));
    }

    resetSearch() {
        const searchInput = this.querySelector("#pickup-search");
        if (searchInput) {
            searchInput.value = "";
            this.pickupItems = Array.from(this.querySelectorAll(".pickup__list__item"));
            this.pickupItems?.forEach(i => (i.style.display = ""));
        }
    }

    restoreSelection() {
        const jsonLocalEl = document.querySelector("[data-json-local]");
        const id_store = jsonLocalEl ? (jsonLocalEl.getAttribute("data-json-local") || '') : '';
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let savedStore = localStorage.getItem("selectedPickupStore");
        const savedVariantPickup = localStorage.getItem("selectedVariant");

        const labelStore = this.querySelector(".click-and-collect-title-sub");
        if (id_store != '') {
            const list_id = id_store.split(",");
            list_id.forEach((value, index) => {
                const storeId = urlParams.get('store');
                const id = value.split(":")[0];
                if (storeId == id) {
                    savedStore = value.split(":")[1];
                    localStorage.setItem("selectedPickupStore", savedStore);
                }
            })
        }
        if (labelStore) {
            labelStore.textContent = savedStore || "Select Store";
        }

        if (!savedStore) return;

        this.pickupItems = Array.from(this.querySelectorAll(".pickup__list__item"));

        const matched = this.pickupItems.find(item => {
            const name = item.querySelector(".address_name")?.innerText.trim();
            return name === savedStore;
        });

        if (matched) {
            if (this.infoContainer) {
                const target = this.infoContainer.querySelector(".pick-up-item-content");
                const sourceContent = matched.querySelector(".pick-up-item-content")?.innerHTML || "";
                if (target) target.innerHTML = sourceContent;
            }

            this.markSelectedUI(matched);
        } else {
            const propertyPickup = document.querySelector("#pick-up-property");
            if (propertyPickup) propertyPickup.value = savedStore;
        }
    }

    updateButtonLabel(item, label) {
        const button = item.querySelector(".select-pick-up-address");
        if (button) button.textContent = label;
    }

    async updateCartPickupStore(storeName) {
        try {
            const cart = await fetch("/cart.js").then(res => res.json());

            for (const item of cart.items) {
                await fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        id: item.key,
                        quantity: item.quantity,
                        properties: {
                            ...item.properties,
                            _pickup_store_name: storeName
                        }
                    })
                });
            }
        } catch (e) {
            console.error("Update pickup store failed", e);
        }
    }

}

customElements.define("click-and-collect-wrapper", ClickAndCollectWrapper);

document.addEventListener('theme:variant:change', () => {
    const wrapper = document.querySelector("click-and-collect-wrapper");
    if (wrapper) {
        setTimeout(() => {
            wrapper.waitForPickupElements();
            wrapper.restoreSelection();
        }, 1500);
    }
});
